import { extendTheme } from "@chakra-ui/react";
import { StyleFunctionProps, mode } from "@chakra-ui/theme-tools";
import "@fontsource-variable/inter-tight";
import "@fontsource/open-sans";
import "@fontsource/raleway";

const letterSpacing = 0.5;

export const theme = extendTheme({
  fonts: {
    heading: `'Inter Tight Variable', sans-serif`,
    body: `'Inter Tight Variable', sans-serif`,
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 700,
    extraBold: 800,
  },
  config: {
    initialColorMode: "system",
    useSystemColorMode: true,
  },
  styles: {
    global: (props: Record<string, string> | StyleFunctionProps) => ({
      "html, body": {
        bg: mode("#ffffff", "#000000")(props),
        letterSpacing: letterSpacing,
        minHeight: "100vh",
        color: mode("#000000", "#FAFAFA")(props),
      },
    }),
  },
  components: {
    Text: {
      baseStyle: {
        letterSpacing: letterSpacing,
      },
    },
    Heading: {
      baseStyle: {
        letterSpacing: letterSpacing,
      },
    },
  },
});
